<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";
import decode from "jwt-decode";

export default {
  name: "callback",
  watch: {
    // call again the method if the route changes
    $route: "fetchData"
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["signIn"]),
    async fetchData() {
      try {
        let token = this.$route.query.access_token;
        let decoded = decode(token);
        let payload = {
          access_token: token,
          expires_at: decoded.exp
        };

        await this.signIn(payload);
        let path = this.$store.state.session.redirectUrl
          ? this.$store.state.session.redirectUrl
          : process.env.VUE_APP_SSO_REDIRECT;

        this.$store.commit("REDIRECT_SET", { redirectUrl: null });
        this.$router.push({ path: path });
      } catch (err) {
        console.error(err);
        this.$router.push({ path: "/sign-in" });
      }
    }
  }
};
</script>
